import api from '../api';
import wemogaApi from '../wemogaApi';
import { getUser } from '../user';
import {
  ResponseSplitTransactionsList,
  RegisterReceiver,
  GetSplitTotalsReportProps,
  GetSplitTransactionListProps,
} from './type';

export const getSplitTotalsReport = async ({
  startDate, endDate,
}:GetSplitTotalsReportProps) => {
  try {
    const user = getUser();
    const receiverId = user.receiverHash || user.userId;
    
    console.log('📋 getSplitTotalsReport - Receiver ID:', receiverId);
    
    const { data: response } = await wemogaApi.get(
      `/dashboard/receivers/${receiverId}/reports?startDate=${startDate}&endDate=${endDate}`,
    );
    return response;
  } catch (error: any) {
    throw error?.response;
  }
};

export const getSplitTransactionsListData = async ({
  startDate, endDate, limit, page,
}:GetSplitTransactionListProps): Promise<ResponseSplitTransactionsList> => {
  try {
    const user = getUser();
    const receiverId = user.receiverHash || user.userId;
    
    console.log('📋 getSplitTransactionsListData - Receiver ID:', receiverId);
    console.log('📋 Usuario completo:', user);
    
    const requestUrl = `/dashboard/receivers/${receiverId}/transactions?startDate=${startDate}&endDate=${endDate}&limit=${limit}&page=${page}`;
    console.log('📋 URL da requisição:', requestUrl);
    
    const { data: response } = await wemogaApi.get(requestUrl);
    return response;
  } catch (error: any) {
    console.error('📋 Erro ao buscar transações:', error?.response || error);
    throw error?.response;
  }
};

export const getBankCodeList = async () => {
  try {
    const { data: response } = await api.get('/banks');
    return response;
  } catch (error: any) {
    throw error?.response;
  }
};

export const postReceiverCreate = async (data : RegisterReceiver) => {
  try {
    const { data: response } = await api.post('receivers', data);
    return response;
  } catch (error: any) {
    throw error?.response;
  }
};
